import PropTypes from "prop-types";
import { useWatch } from "react-hook-form";

import { FieldGroup } from "@/components/ui/field";
import {
  FormInput,
  FormRecordMultiPicker,
  FormSuggestChipList,
  LocationFields,
  SectionCard,
} from "components/BaseForm";
import { formatUserName, isUserActive } from "helpers/user";
import EntityService from "services/Entity";
import UserService from "services/User";

const withSearch = search => (search ? { search_query: search } : {});

const fetchWebsites = async search => {
  const websites = await EntityService.getWebsitesForFilters({
    search_query: search,
  });
  return websites.map(({ name }) => name);
};

const DetailsSection = ({ accountManagerDisplay }) => {
  const accountManagerIds = useWatch({ name: "account_managers" });

  // Deactivated users are not offered, except those already assigned.
  const fetchAccountManagers = async search => {
    const users = await UserService.getUsersForFilters(withSearch(search));
    return users
      .filter(
        user =>
          user.id > 0 &&
          (accountManagerIds.includes(user.id) || isUserActive(user))
      )
      .map(user => ({ ...user, name: formatUserName(user.name, user.status) }));
  };

  return (
    <SectionCard title="Details">
      <FieldGroup className="tw:grid tw:grid-cols-1 tw:gap-5 tw:md:grid-cols-2">
        <FormInput name="name" label="Name" required />
        <FormSuggestChipList
          name="urls"
          label="URLs"
          placeholder="Type a URL and press Enter"
          fetchSuggestions={fetchWebsites}
          suggestionsKey="entity-websites"
        />
        <FormRecordMultiPicker
          name="account_managers"
          label="Account Managers"
          placeholder="Pick Account Managers"
          fetchOptions={fetchAccountManagers}
          optionsKey="entity-account-managers"
          display={accountManagerDisplay}
        />
        <FormInput
          name="external_cc_emails"
          label="External CC Emails"
          placeholder="email1@example.com,email2@example.com"
        />
        <LocationFields />
      </FieldGroup>
    </SectionCard>
  );
};

DetailsSection.propTypes = {
  accountManagerDisplay: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, label: PropTypes.string })
  ),
};

export default DetailsSection;
